import type { HealthGrade, HealthLabel } from "./types";

export const COVERAGE_WEIGHT = 0.3;
export const POSITION_WEIGHT = 0.5;
export const MOMENTUM_WEIGHT = 0.2;

export const NOT_RANKED_PENALTY_POSITION = 45;

/** Position changes within this band are treated as "stable" */
export const STABILITY_BAND = 2;

/** Linear scale: position 1 → score 100, position 50 → score 0 */
export const POSITION_SCALE_MAX = 49;

export const GRADE_THRESHOLDS: readonly { grade: HealthGrade; min: number }[] = [
  { grade: "A", min: 80 },
  { grade: "B", min: 60 },
  { grade: "C", min: 40 },
  { grade: "D", min: 20 },
  { grade: "F", min: 0 },
];

export const GRADE_METADATA: Record<
  HealthGrade,
  { label: HealthLabel; color: string }
> = {
  A: { label: "Excellent", color: "var(--color-accent-green)" },
  B: { label: "Good", color: "var(--color-accent-blue)" },
  C: { label: "Fair", color: "var(--color-accent-yellow)" },
  D: { label: "Poor", color: "var(--color-accent-red)" },
  F: { label: "Critical", color: "var(--color-accent-red)" },
};
